import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import CurrencyForm from "@components/forms/CurrencyForm";

const CurrencyAddEdit = () => {
  const params = useParams()
  const { id: currencyId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!currencyId ? 'Agregar' : 'Editar'} Moneda`}
      backUrl="/user/currencies"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "currencyForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <CurrencyForm
        formId="currencyForm"
        id={currencyId}
        saveRedirectUrl="/user/currencies"
      ></CurrencyForm>

    </PageContainer>
  );
}

export default CurrencyAddEdit;
